import styled from "styled-components";
import { Table as TableAntd } from "antd";

const Table = ({ ...rest }) => {
  return (
    <TableWarp>
      <TableAntd {...rest} />
    </TableWarp>
  );
};

export default Table;

const TableWarp = styled.div`
  width: 100%;
  & .ant-table-thead > tr > th {
    background: #eef1f4;
    color: #1f2933;
    font-weight: 400;
    vertical-align: middle;
    line-height: 1.4;
    padding-top: 14px;
    padding-bottom: 14px;
  }
  & .ant-table-tbody > tr > td {
    vertical-align: middle;
  }
  &
    .ant-table-thead
    > tr
    > th:not(:last-child):not(.ant-table-selection-column):not(
      .ant-table-row-expand-icon-cell
    ):not([colspan]):before {
    content: unset;
  }
  & .ant-table-container,
  .ant-table-container table > thead > tr:first-child th:first-child {
    border-top-left-radius: 8px;
  }
  & .ant-table-container table > thead > tr:first-child th:last-child {
    border-top-right-radius: 8px;
  }
  & .ant-table-tbody tr:nth-child(odd) {
    background: #fff;
  }
  & .ant-table-tbody tr:nth-child(even) {
    background: #fafafa;
  }
  /* out-of-range rows (opt-in via rowClassName="row-breach") — !important beats
     the zebra stripes and any per-column cell tint */
  & .ant-table-tbody > tr.row-breach > td {
    background: #fef2f2 !important;
  }
  & .ant-table-tbody > tr.row-breach:hover > td {
    background: #fde3e3 !important;
  }
  /* excursions that returned in-range within the device's alert delay — soft
     amber, distinct from the red alarm rows above */
  & .ant-table-tbody > tr.row-breach-brief > td {
    background: #fffbeb !important;
  }
  & .ant-table-tbody > tr.row-breach-brief:hover > td {
    background: #fef3c7 !important;
  }
  /* pagination layout: total count + page-size selector on the LEFT, page
     navigation pushed to the RIGHT */
  & .ant-table-pagination {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: flex-start;
  }
  /* page-size selector far LEFT, total/range text CENTERED, page nav on the RIGHT */
  & .ant-pagination-options {
    order: -2;
    margin-left: 0;
    margin-right: 0;
  }
  & .ant-pagination-total-text {
    order: -1;
    margin: 0 auto;
    color: #64748b;
  }
  & .ant-pagination-item-active a {
    color: rgba(0, 0, 0, 0.85);
  }
  & .ant-pagination-item-active {
    background: #febc11;
    border-color: #febc11;
  }
  & .ant-pagination-item:hover {
    background: #febc11;
    border-color: #febc11;
  }
  & .ant-pagination-item:hover a {
    color: rgba(0, 0, 0, 0.85);
  }
  & .ant-pagination-next:focus-visible .ant-pagination-item-link,
  .ant-pagination-next:hover .ant-pagination-item-link,
  .ant-pagination-prev:focus-visible .ant-pagination-item-link,
  .ant-pagination-prev:hover .ant-pagination-item-link {
    color: rgba(0, 0, 0, 0.85);
    border-color: #febc11;
    background: #febc11;
  }
  & .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
    background: #febc11;
  }
  & .ant-select:not(.ant-select-disabled):hover .ant-select-selector {
    border-color: #febc11;
  }
`;
